module.exports = __webpack_public_path__ + "img/nameatl12.4fbd1788.jpg";